import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import scrollToTop from "../components/hooks/ScrollToTop";
import './css/templates.css';

const PoliciesProcedures = () => {
  const { t } = useTranslation();

  useEffect(() => {
    scrollToTop();
  }, []);

   useEffect(()=>{
      const html = document.getElementsByTagName('html')[0];
      html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
      html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
      window.Webflow && window.Webflow.destroy();
      window.Webflow && window.Webflow.ready();
      window.Webflow && window.Webflow.require('ix2').init();
      document.dispatchEvent(new Event('readystatechange'))
      },[])

  return (
    <div>
      <div className="page-wrapper">
        <Navbar />
        <div className="hero-wrapper hero-7 space" id="hero">
          <div className="container-space">
            <div className="row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper">
              <div>

                <h3
                  className="text-center links-heading item-heading-font"
                  style={{ fontSize: "26px", color: "#ee7c2c", textAlign: "center" ,marginBottom: "2rem",textTransform: "uppercase"}}
                >{t("mainPoliciesTitle")}</h3>

                <h3 className="text-center links-heading item-heading-font"
                style={{ fontSize: "24px", color: "#ee7c2c" }}>
                 {t("tableOfContents")}
                </h3>

                <p className="agreement-para sub-heading"><span>{t("section1.0")}</span><u>{t("section1.0introduction")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section1.0mutualCommitmentStatement1.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section1.0codeOfEthics1.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section1.0noaPoliciesProceduresCompensationPlan1.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section1.0purposeOfPoliciesProcedures1.4")}</p>
                <p className="mtb-1rem pd-l-3">{t("section1.0changesAmendmentsModifications1.5")}</p>


                {/* SECTION 2.0 */}
                <p className="agreement-para sub-heading"><span>{t("section2.0")}</span><u>{t("section2.0basicPrinciples")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section2.0becomingAnAffiliate2.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section2.0newAffiliateRegistration2.2")}</p>
                
                {/* SECTION 3.0 */}
                <p className="agreement-para sub-heading"><span>{t("section3.0")}</span><u>{t("section3.0noaAffiliateResponsibilities")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section3.0correctAddress3.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section3.0trainingAndLeadership3.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section3.0sponsorship3.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section3.0unethicalSponsoring3.4")}</p>
                <p className="mtb-1rem pd-l-3">{t("section3.0crossSponsoringProhibited3.5")}</p>
                <p className="mtb-1rem pd-l-3">{t("section3.0solicitationForOtherCompaniesOrServices3.6")}</p>
                
                {/* SECTION 4.0 */}
                <p className="agreement-para sub-heading"><span>{t("section4.0")}</span><u>{t("section4.0agreementAndGeneralUnderstandings")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section4.0rightsGranted4.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0renewalsAndExpirationOfTheNoaAgreement4.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0effectOfCancellation4.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0modificationOfTheAffiliateAgreement4.4")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0unauthorizedTransferAndReEnrollment4.5")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0changeOfSponsorOrPlacementOfActiveAffiliates4.6")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0changeOfOrganizations4.7")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0placementLounge4.8")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0voluntaryTermination4.9")}</p>
                <p className="mtb-1rem pd-l-3">{t("section4.0involuntaryTermination4.10")}</p>
                
                {/* SECTION 5.0 */}
                <p className="agreement-para sub-heading"><span>{t("section5.0")}</span><u>{t("section5.0businessEntities")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section5.0definition5.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section5.0independentBusinessRelationshipIndemnificationForActions5.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section5.0insurance5.3")}</p>
                
                {/* SECTION 6.0 */}
                <p className="agreement-para sub-heading"><span>{t("section6.0")}</span><u>{t("section6.0policyViolations")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section6.0reportingPolicyViolations6.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0adherenceToTheNoaCompensationPlan6.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0adherenceToAllLawsRegulationsOrdinances6.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0complianceWithAllApplicableIncomeTaxLaws6.4")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0oneNoaBusinessPerAffiliate6.5")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0actionsOfHouseholdMembersOrAffiliatedParties6.6")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0identificationNumbersAndPayOut6.7")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0sellAssignOrDelegateOwnership6.8")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0separatingANoaBusiness6.9")}</p>
                <p className="mtb-1rem pd-l-3">{t("section6.0succession6.10")}</p>
                
                {/* SECTION 7.0 */}
                <p className="agreement-para sub-heading"><span>{t("section7.0")}</span><u>{t("section7.0disciplinaryActions")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section7.0impositionOfDisciplinaryActionPurpose7.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section7.0consequencesAndRemedyOfBreach7.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section7.0suspensionProcedures7.3")}</p>
                
                {/* SECTION 8.0 */}
                <p className="agreement-para sub-heading"><span>{t("section8.0")}</span><u>{t("section8.0disputeResolution")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section8.0grievances8.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section8.0mediation8.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section8.0terminationOfMediation8.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section8.0severability8.4")}</p>
                <p className="mtb-1rem pd-l-3">{t("section8.0waiver8.5")}</p>
                <p className="mtb-1rem pd-l-3">{t("section8.0governingLaw8.6")}</p>
                
                {/* SECTION 9.0 */}
                <p className="agreement-para sub-heading"><span>{t("section9.0")}</span><u>{t("section9.0paymentOfCommissionsBonuses")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section9.0bonusAndCommissionsQualifications9.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section9.0computationOfCommissionsDiscrepancies9.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section9.0adjustmentsBonusesCommissionsReturned9.3")}</p>
                
                {/* SECTION 10.0 */}
                <p className="agreement-para sub-heading"><span>{t("section10.0")}</span><u>{t("section10.0ordering")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section10.0generalOrderingPolicies10.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section10.0saleToCustomers10.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section10.0insufficientFunds10.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section10.0creditCardPurchases10.4")}</p>
                <p className="mtb-1rem pd-l-3">{t("section10.0salesTaxObligation10.5")}</p>
                <p className="mtb-1rem pd-l-3">{t("section10.0refundPolicy10.6")}</p>
                <p className="mtb-1rem pd-l-3">{t("section10.0returnProcess10.7")}</p>
                
                {/* SECTION 11.0 */}
                <p className="agreement-para sub-heading"><span>{t("section11.0")}</span><u>{t("section11.0noaOpportunity")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section11.0presentationOfCompensationPlanIncomeClaims11.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section11.0tradingPolicies11.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section11.0events11.3")}</p>
                
                {/* SECTION 12.0 */}
                <p className="agreement-para sub-heading"><span>{t("section12.0")}</span><u>{t("section12.0proprietaryInformationTradeSecrets")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section12.0businessReportsListsProprietaryInformation12.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section12.0obligationOfConfidentiality12.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section12.0breachAndReturnOfMaterials12.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section12.0returnOfMaterials12.4")}</p>
                
                {/* SECTION 13.0 */}
                <p className="agreement-para sub-heading"><span>{t("section13.0")}</span><u>{t("section13.0privacyPolicy")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section13.0introduction13.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section13.0expectationOfPrivacy13.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section13.0employeeAccessToInformation13.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section13.0restrictionsOnDisclosureOfAccountInformation13.4")}</p>
                
                {/* SECTION 14.0 */}
                <p className="agreement-para sub-heading"><span>{t("section14.0")}</span><u>{t("section14.0advertisingPromotionalMaterialUseCompanyNamesTrademarks")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section14.0generalOrderingPolicies14.1")}</p>
                <p className="mtb-1rem pd-l-3">{t("section14.0useOfCompanyNamesProtectedMaterials14.2")}</p>
                <p className="mtb-1rem pd-l-3">{t("section14.0faxesEmailLimitations14.3")}</p>
                <p className="mtb-1rem pd-l-3">{t("section14.0internetThirdPartyWebsiteRestrictions14.4")}</p>
                <p className="mtb-1rem pd-l-3">{t("section14.0advertisingPromotionalMaterials14.5")}</p>
                <p className="mtb-1rem pd-l-3">{t("section14.0testimonialPermission14.6")}</p>
                <p className="mtb-1rem pd-l-3">{t("section14.0telemarketingLimitations14.7")}</p>
                
                {/* SECTION 15.0 */}
                <p className="agreement-para sub-heading"><span>{t("section15.0")}</span><u>{t("section15.0internationalMarketing")}</u></p>
                <p className="mtb-1rem pd-l-3">{t("section15.0internationalMarketingPolicy15.1")}</p>
                
                {/* SECTION 16.0 */}
                <p className="agreement-para sub-heading" style={{paddingBottom:"3rem"}}><span>{t("section16.0")}</span><u>{t("section16.0glossaryOfTerms")}</u></p>


                <h3
                  className="text-center links-heading item-heading-font"
                  style={{ fontSize: "26px", color: "#ee7c2c", textAlign: "center" ,marginBottom: "2rem",textTransform: "uppercase"}}
                >
                  {t("policiesTitle")}
                </h3>

                <h3 className="text-center links-heading item-heading-font"
                style={{ fontSize: "24px", color: "#ee7c2c" }}>
                 1.0 <u>{t("introduction1.0")}</u>
                </h3>

                <p className="agreement-para sub-heading">{t("affiliateAgreement1.1")}</p>
                <p className="agreement-para">{t("definitionAffiliateAgreement1.1")}</p>

                <p className="agreement-para sub-heading">{t("mutualCommitmentStatement1.2")}</p>
                <p className="agreement-para">{t("definitionMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para">{t("1.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("2.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("3.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("4.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("5.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("6.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("7.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("8.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("9.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("10.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("11.lineMutualCommitmentStatement1.2")}</p>
                <p className="agreement-para pd-l-3">{t("12.lineMutualCommitmentStatement1.2")}</p>


                <p className="agreement-para sub-heading">{t("codeOfEthics1.3")}</p>
                <p className="agreement-para">{t("(a)lineCodeOfEthics1.3")}</p>
                <p className="agreement-para pd-l-3">{t("1lineCodeOfEthics1.3")}</p>
                <p className="agreement-para pd-l-3">{t("2lineCodeOfEthics1.3")}</p>
                <p className="agreement-para pd-l-3">{t("3lineCodeOfEthics1.3")}</p>
                <p className="agreement-para pd-l-3">{t("4lineCodeOfEthics1.3")}</p>
                <p className="agreement-para pd-l-3">{t("5lineCodeOfEthics1.3")}</p>
                <p className="agreement-para pd-l-3">{t("6lineCodeOfEthics1.3")}</p>
                <p className="agreement-para">{t("(b)lineCodeOfEthics1.3")}</p>
                <p className="agreement-para">{t("(c)lineCodeOfEthics1.3")}</p>

                <p className="agreement-para sub-heading">{t("purposeOfPoliciesProcedures1.4")}</p>
                <p className="agreement-para">{t("(a)linePurposeOfPoliciesProcedures1.4")}</p>
                <p className="agreement-para">{t("(b)linePurposeOfPoliciesProcedures1.4")}</p>
                <p className="agreement-para">{t("(c)linePurposeOfPoliciesProcedures1.4")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa">{t("support@joinnoa.io")}</a>
                </p>
                <p className="agreement-para">{t("(d)linePurposeOfPoliciesProcedures1.4first")}
                  <a href="https://joinnoa.io/" target="_blank"  className="orange-noa">{t("www.joinnoa.io")}</a>
                  {t("(d)linePurposeOfPoliciesProcedures1.4second")}
                </p>


                <p className="agreement-para sub-heading">{t("changesAmendmentsModifications1.5")}</p>
                <p className="agreement-para">{t("(a)lineChangesAmendmentsModifications1.5")}</p>
                <p className="agreement-para">{t("(b)lineChangesAmendmentsModifications1.5")}</p>
                <p className="agreement-para pd-l-3">{t("1lineChangesAmendmentsModifications1.5")}
                  <a href="https://joinnoa.io/" target="_blank"  className="orange-noa">{t("www.joinnoa.io")}</a>
                </p>
                <p className="agreement-para pd-l-3">{t("2lineChangesAmendmentsModifications1.5")}</p>
                <p className="agreement-para pd-l-3">{t("3lineChangesAmendmentsModifications1.5")}</p>

                <h3 className="text-center links-heading item-heading-font"
                style={{ fontSize: "24px", color: "#ee7c2c" }}>
                 2.0 <u>{t("basicPrinciles2.0")}</u>
                </h3>

                <p className="agreement-para sub-heading">{t("becomingAnAffiliate2.1")}</p>
                 <p className="agreement-para">{t("lineBecomingAnAffiliate2.1")}</p>
                 <p className="agreement-para pd-l-3">{t("1lineBecomingAnAffiliate2.1")}</p>
                 <p className="agreement-para pd-l-3">{t("2lineBecomingAnAffiliate2.1")}</p>
                 <p className="agreement-para pd-l-3">{t("3lineBecomingAnAffiliate2.1")}</p>
                 <p className="agreement-para pd-l-3">{t("4lineBecomingAnAffiliate2.1")}</p>
                 
                                 
                <p className="agreement-para sub-heading">{t("newAffiliateRegistration2.2")}</p>
                <p className="agreement-para">{t("(a)lineNewAffiliateRegistration2.2")}</p>
                <p className="agreement-para">{t("(b)lineNewAffiliateRegistration2.2")}</p>


                <h3 className="text-center links-heading item-heading-font"
                style={{ fontSize: "20px", color: "#ee7c2c" }}>
                 3.0 <u>{t("noaAffiliateResponsibilities3.0")}</u>
                </h3>

                <p className="agreement-para sub-heading">{t("correctAffiliateInformation3.1")}</p>
                <p className="agreement-para">{t("(a)lineCorrectAffiliateInformation3.1")}</p>
                <p className="agreement-para">{t("(b)lineCorrectAffiliateInformation3.1")}</p>

                <p className="agreement-para sub-heading">{t("trainingAndLeadership3.2")}</p>
                <p className="agreement-para">{t("(a)lineTrainingAndLeadership3.2")}</p>
                <p className="agreement-para">{t("(b)lineTrainingAndLeadership3.2")}</p>
                <p className="agreement-para">{t("(c)lineTrainingAndLeadership3.2")}</p>
                <p className="agreement-para">{t("(d)lineTrainingAndLeadership3.2")}</p>
                <p className="agreement-para">{t("(e)lineTrainingAndLeadership3.2")}</p>


                <p className="agreement-para sub-heading">{t("sponsorship3.3")}</p>
                <p className="agreement-para">{t("(a)lineSponsorship3.3")}</p>
                <p className="agreement-para">{t("(b)lineSponsorship3.3")}</p>
                <p className="agreement-para">{t("(c)lineSponsorship3.3")}</p>
                <p className="agreement-para">{t("(d)lineSponsorship3.3")}</p>

                <p className="agreement-para sub-heading">{t("unethicalSponsoring3.4")}</p>
                <p className="agreement-para">{t("(a)lineUnethicalSponsoring3.4")}</p>
                <p className="agreement-para">{t("(b)lineUnethicalSponsoring3.4")}</p>
                <p className="agreement-para">{t("(c)lineUnethicalSponsoring3.4")}</p>
                <p className="agreement-para">{t("(d)lineUnethicalSponsoring3.4")}</p>

                <p className="agreement-para sub-heading">{t("crossSponsoringRecruitingProhibition3.5")}</p>
                <p className="agreement-para">{t("(a)lineCrossSponsoringRecruitingProhibition3.5")}</p>
                <p className="agreement-para">{t("(b)lineCrossSponsoringRecruitingProhibition3.5")}</p>
                <p className="agreement-para">{t("(c)lineCrossSponsoringRecruitingProhibition3.5")}</p>
                <p className="agreement-para">{t("(d)lineCrossSponsoringRecruitingProhibition3.5")}</p>

                <p className="agreement-para sub-heading">{t("solicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(a)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(b)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(c)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(d)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(e)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(f)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(g)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(h)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(i)lineSolicitationForOtherCompaniesServices3.6")}</p>
                <p className="agreement-para">{t("(j)lineSolicitationForOtherCompaniesServices3.6")}</p>
                 

                <h3 className="text-center links-heading item-heading-font"
                style={{ fontSize: "20px", color: "#ee7c2c" }}>
                 4.0 <u>{t("agreementsAndGeneralUnderstandings4.0")}</u>
                </h3>

                <p className="agreement-para sub-heading">{t("rightsGranted4.1")}</p>
                <p className="agreement-para">{t("1lineRightsGranted4.1")}</p>
                <p className="agreement-para pd-l-3">{t("2lineRightsGranted4.1")}</p>
                <p className="agreement-para pd-l-3">{t("3lineRightsGranted4.1")}</p>
                <p className="agreement-para">{t("4lineRightsGranted4.1")}</p>


                <p className="agreement-para sub-heading">{t("renewalsAndExpirationTheAffiliateAgreement4.2")}</p>
                <p className="agreement-para">{t("1lineRenewalsAndExpirationTheAffiliateAgreement4.2")}</p>
                <p className="agreement-para pd-l-3">{t("2lineRenewalsAndExpirationTheAffiliateAgreement4.2")}</p>
                <p className="agreement-para pd-l-3">{t("3lineRenewalsAndExpirationTheAffiliateAgreement4.2")}</p>
                <p className="agreement-para pd-l-3">{t("4lineRenewalsAndExpirationTheAffiliateAgreement4.2")}</p>

                <p className="agreement-para sub-heading">{t("effectOfCancellation4.3")}</p>
                <p className="agreement-para">{t("1lineEffectOfCancellation4.3")}</p>
                <p className="agreement-para pd-l-3">{t("2lineEffectOfCancellation4.3")}</p>
                <p className="agreement-para pd-l-3">{t("3lineEffectOfCancellation4.3")}</p>
                <p className="agreement-para pd-l-3">{t("4lineEffectOfCancellation4.3")}</p>

                <p className="agreement-para sub-heading">{t("changesToAffiliateAccount4.4")}</p>
                <p className="agreement-para">{t("(a)lineChangesToAffiliateAccount4.4")}</p>
                <p className="agreement-para">{t("(b)lineChangesToAffiliateAccount4.4")}</p>

                <p className="agreement-para sub-heading">{t("unauthorizedTransferReEnrollment4.5")}</p>
                <p className="agreement-para">{t("1lineUnauthorizedTransferReEnrollment4.5")}</p>


                <p className="agreement-para sub-heading">{t("changeOfSponsorsPlacementForAffiliates4.6")}</p>
                <p className="agreement-para">{t("(a)lineChangeOfSponsorsPlacementForAffiliates4.6")}</p>
                <p className="agreement-para">{t("(b)lineChangeOfSponsorsPlacementForAffiliates4.6")}</p>
                <p className="agreement-para">{t("(c)lineChangeOfSponsorsPlacementForAffiliates4.6")}</p>
                <p className="agreement-para">{t("(d)lineChangeOfSponsorsPlacementForAffiliates4.6")}</p>
                <p className="agreement-para">{t("(e)lineChangeOfSponsorsPlacementForAffiliates4.6")}</p>
                <p className="agreement-para">{t("(f)lineChangeOfSponsorsPlacementForAffiliates4.6")}</p>

                <p className="agreement-para sub-heading">{t("changeOrganizations4.7")}</p>
                <p className="agreement-para">{t("(a)lineChangeOrganizations4.7")}</p>
                <p className="agreement-para">{t("(b)lineChangeOrganizations4.7")}</p>
                <p className="agreement-para">{t("(c)lineChangeOrganizations4.7")}</p>


                <p className="agreement-para sub-heading">{t("voluntaryTermination4.8")}</p>
                <p className="agreement-para">{t("(a)lineoluntaryTermination4.8first")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa">{t("support@joinnoa.io")}</a>
                  {t("(a)lineoluntaryTermination4.8second")}
                </p>
                <p className="agreement-para pd-l-3">{t("1lineoluntaryTermination4.8")}</p>
                <p className="agreement-para pd-l-3">{t("2lineoluntaryTermination4.8")}</p>
                <p className="agreement-para pd-l-3">{t("3lineoluntaryTermination4.8")}</p>
                <p className="agreement-para pd-l-3">{t("4lineoluntaryTermination4.8")}</p>
                <p className="agreement-para">{t("(b)lineoluntaryTermination4.8")}</p>


                <p className="agreement-para sub-heading">{t("involuntaryTermination4.9")}</p>
                <p className="agreement-para">{t("(a)lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para pd-l-3">{t("1lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para pd-l-3">{t("2lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para pd-l-3">{t("3lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para pd-l-3">{t("4lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para">{t("(b)lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para">{t("(c)lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para">{t("(d)lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para">{t("(e)lineInvoluntaryTermination4.9")}</p>
                <p className="agreement-para">{t("(f)lineInvoluntaryTermination4.9")}</p>

                <h3 className="text-center links-heading item-heading-font" style={{ fontSize: "20px", color: "#ee7c2c" }}>
                 5.0 <u>{t("businessEntities5.0")}</u>
                </h3>
                
                <p className="agreement-para sub-heading">{t("definition5.1")}</p>
                <p className="agreement-para">{t("(a)lineDefinition5.1")}</p>
                <p className="agreement-para">{t("(b)lineDefinition5.1")}</p>


                <p className="agreement-para sub-heading">
                  {t("independentBusinessRelationshipIndemnificationForActions5.2")}
                </p>
                <p className="agreement-para">
                  {t("(a)lineIndependentBusinessRelationshipIndemnificationForActions5.2")}
                </p>
                <p className="agreement-para pd-l-3">
                  {t("1lineIndependentBusinessRelationshipIndemnificationForActions5.2")}
                </p>
                <p className="agreement-para pd-l-3">
                  {t("2lineIndependentBusinessRelationshipIndemnificationForActions5.2")}
                </p>
                <p className="agreement-para">
                  {t("(b)lineIndependentBusinessRelationshipIndemnificationForActions5.2")}
                </p>
                <p className="agreement-para">
                  {t("(c)lineIndependentBusinessRelationshipIndemnificationForActions5.2")}
                </p>


                <p className="agreement-para sub-heading">
                  {t("insurance5.3")}
                </p>
                <p className="agreement-para">
                  {t("lineInsurance5.3")}
                </p>


                <h3 className="text-center links-heading item-heading-font" style={{ fontSize: "20px", color: "#ee7c2c" }}>
                  6.0 <u>{t("policyViolations6.0")}</u>
                </h3>
                
                <p className="agreement-para sub-heading">{t("reportingPolicyViolation6.1")}</p>
                <p className="agreement-para">{t("lineReportingPolicyViolation6.1first")}
                  <a href="mailto:compliance@joinnoa.io"  className="orange-noa">{t("compliance@joinnoa.io")}</a>
                  {t("lineReportingPolicyViolation6.1second")}
                </p>
                <p className="agreement-para pd-l-3">{t("(i)lineReportingPolicyViolation6.1")}</p>
                <p className="agreement-para pd-l-3">{t("(ii)lineReportingPolicyViolation6.1")}</p>
                <p className="agreement-para pd-l-3">{t("(iii)lineReportingPolicyViolation6.1")}</p>
                <p className="agreement-para pd-l-3">{t("(iv)lineReportingPolicyViolation6.1")}</p>
                <p className="agreement-para pd-l-3">{t("(v)lineReportingPolicyViolation6.1")}</p>
                <p className="agreement-para pd-l-3">{t("(vi)lineReportingPolicyViolation6.1")}</p>


                <p className="agreement-para sub-heading">{t("adherenceToTheNOACompensationPlan6.2")}</p>
                <p className="agreement-para">{t("(a)lineAdherenceToTheNOACompensationPlan6.2")}</p>
                <p className="agreement-para">{t("(b)lineAdherenceToTheNOACompensationPlan6.2")}</p>
                <p className="agreement-para">{t("(c)lineAdherenceToTheNOACompensationPlan6.2")}</p>
                <p className="agreement-para">{t("(d)lineAdherenceToTheNOACompensationPlan6.2")}</p>
                
                <p className="agreement-para sub-heading">{t("adherenceToLawsAndOrdinances6.3")}</p>
                <p className="agreement-para">{t("(a)lineAdherenceToLawsAndOrdinances6.3")}</p>
                <p className="agreement-para">{t("(b)lineAdherenceToLawsAndOrdinances6.3")}</p>
                <p className="agreement-para">{t("(c)lineAdherenceToLawsAndOrdinances6.3")}</p>
                
                <p className="agreement-para sub-heading">{t("complianceWithApplicableIncomeTaxLaws6.4")}</p>
                <p className="agreement-para">{t("(a)lineComplianceWithApplicableIncomeTaxLaws6.4")}</p>
                <p className="agreement-para">{t("(b)lineComplianceWithApplicableIncomeTaxLaws6.4")}</p>
                <p className="agreement-para">{t("(c)lineComplianceWithApplicableIncomeTaxLaws6.4")}</p>


                <p className="agreement-para sub-heading">{t("oneNoaBusinessPerAffiliate6.5")}</p>
                <p className="agreement-para">{t("lineOneNoaBusinessPerAffiliate6.5")}</p>
                
                <p className="agreement-para sub-heading">{t("actionsOfHouseholdMembers6.6")}</p>
                <p className="agreement-para">{t("lineActionsOfHouseholdMembers6.6")}</p>
                
                <p className="agreement-para sub-heading">{t("identificationNumbersPayOut6.7")}</p>
                <p className="agreement-para">{t("(a)lineIdentificationNumbersPayOut6.7")}</p>
                <p className="agreement-para">{t("(b)lineIdentificationNumbersPayOut6.7")}</p>
                <p className="agreement-para">{t("(c)lineIdentificationNumbersPayOut6.7")}</p>
                
                <p className="agreement-para sub-heading">{t("sellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para">{t("(a)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para">{t("(b)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para">{t("(c)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para">{t("(d)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para pd-l-3">{t("(d)(i)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para pd-l-3">{t("(d)(ii)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para pd-l-3">{t("(d)(iii)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para pd-l-3">{t("(d)(iv)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para pd-l-3">{t("(d)(v)lineSellAssignDelegateOwnership6.8")}</p>
                <p className="agreement-para">{t("(e)lineSellAssignDelegateOwnership6.8")}</p>


                <p className="agreement-para sub-heading">{t("separatingNOABusiness6.9")}</p>

                <p className="agreement-para">{t("(a)separatingNOABusiness6.9")}</p>
                <p className="agreement-para pd-l-3">{t("(a)(i)separatingNOABusiness6.9")}</p>
                <p className="agreement-para pd-l-3">{t("(a)(ii)separatingNOABusiness6.9")}</p>
                
                <p className="agreement-para">{t("(b)separatingNOABusiness6.9")}</p>
                
                <p className="agreement-para">{t("(c)separatingNOABusiness6.9")}</p>


                <p className="agreement-para sub-heading">{t("succession6.10")}</p>

                 <p className="agreement-para">{t("(a)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(b)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("1lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(ii)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(iii)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(iv)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(c)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(d)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(e)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(i)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(ii)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(f)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(i)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(ii)lineSuccession6.10")}</p>
                 <p className="agreement-para pd-l-3">{t("(iii)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(g)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(h)lineSuccession6.10")}</p>
                 
                 <p className="agreement-para">{t("(i)lineSuccession6.10")}</p>

                  <h3 className="text-center links-heading item-heading-font" style={{ fontSize: "20px", color: "#ee7c2c" }}>
                  7.0 <u>{t("disciplinaryActions7.0")}</u>
                </h3>

                <p className="agreement-para sub-heading">{t("impositionOfDisciplinaryActionPurpose7.1")}</p>
                <p className="agreement-para">{t("lineImpositionOfDisciplinaryActionPurpose7.1")}</p>
                
                <p className="agreement-para sub-heading">{t("consequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(i)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(ii)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(iii)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(iv)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(v)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(vi)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(vii)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(viii)lineConsequencesAndRemediesOfBreach7.2")}</p>
                <p className="agreement-para">{t("(ix)lineConsequencesAndRemediesOfBreach7.2")}</p>



                <p className="agreement-para sub-heading">{t("suspensionProcedures7.3")}</p>

                 <p className="agreement-para">{t("(a)lineSuspensionProcedures7.3")}</p>
                 
                 <p className="agreement-para">{t("(b)lineSuspensionProcedures7.3")}</p>
                 <p className="agreement-para pd-l-3">{t("(i)lineBFirstViolationSuspensionProcedures7.3")}</p>
                 
                 <p className="agreement-para">{t("(c)lineSuspensionProcedures7.3")}</p>
                 <p className="agreement-para pd-l-3">{t("(i)lineCSecondViolationSuspensionProcedures7.3")}</p>
                 
                 <p className="agreement-para">{t("(d)lineSuspensionProcedures7.3")}</p>
                 
                 <p className="agreement-para">{t("(e)lineSuspensionProcedures7.3")}</p>



                  <h3 className="text-center links-heading item-heading-font" style={{ fontSize: "20px", color: "#ee7c2c" }}>
                  8.0 <u>{t("disputeResolution8.0")}</u>
                </h3>

                 <p className="agreement-para sub-heading">{t("grievancesBetweenAffiliates8.1")}</p>
                 <p className="agreement-para">{t("(a)lineGrievancesBetweenAffiliates8.1")}</p>
                 <p className="agreement-para">{t("(b)lineGrievancesBetweenAffiliates8.1")}</p>
                 <p className="agreement-para">{t("(c)lineGrievancesBetweenAffiliates8.1")}</p>
                 <p className="agreement-para">{t("(d)lineGrievancesBetweenAffiliates8.1")}</p>
                 <p className="agreement-para">{t("(e)lineGrievancesBetweenAffiliates8.1")}</p>
                 <p className="agreement-para pd-l-3">{t("(i)lineEProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(A)lineEIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(B)lineEIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(C)lineEIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(D)lineEIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(E)lineEIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(F)lineEIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3">{t("(ii)lineEProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(A)lineEIIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(B)lineEIIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(C)lineEIIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(D)lineEIIProcessForGrievances8.1")}</p>
                 <p className="agreement-para pd-l-3rem">{t("(E)lineEIIProcessForGrievances8.1")}</p>


                 <p className="agreement-para sub-heading">{t("disputeResolution8.2")}</p>
                 <p className="agreement-para" style={{fontWeight:"bold"}}>{t("readCarefullyDisputeResolution8.2")}</p>
                 <p className="agreement-para">{t("(a)lineDisputeResolution8.2")}</p>
                 <p className="agreement-para">{t("(b)lineDisputeResolution8.2")}</p>
                 <p className="agreement-para" style={{fontWeight:"bold"}}>{t("(c)lineClassActionWaiver8.2")}</p>
                 <p className="agreement-para" style={{fontWeight:"bold"}}>{t("(d)lineJuryTrialWaiver8.2")}</p>
                 <p className="agreement-para">{t("(e)lineDelegationToArbitrator8.2")}</p>
                 <p className="agreement-para">{t("(f)lineSeverability8.2")}</p>
                 <p className="agreement-para">{t("(g)lineTermination8.2")}</p>


                 <p className="agreement-para sub-heading">{t("severability8.3")}</p>
                 <p className="agreement-para">{t("lineSeverability8.3")}</p>
                 
                 <p className="agreement-para sub-heading">{t("waiver8.4")}</p>
                 <p className="agreement-para">{t("(a)lineWaiver8.4")}</p>
                 <p className="agreement-para">{t("(b)lineWaiver8.4")}</p>
                 <p className="agreement-para">{t("(c)lineWaiver8.4")}</p>
                 
                 <p className="agreement-para sub-heading">{t("governingLaw8.5")}</p>
                 <p className="agreement-para">{t("lineGoverningLaw8.5")}</p>


                  <h3 className="text-center links-heading item-heading-font" style={{ fontSize: "20px", color: "#ee7c2c" }}>
                   9.0 <u>{t("paymentOfCommissionsBonuses9.0")}</u>
                </h3>

                  <p className="agreement-para sub-heading">{t("bonusCommissionQualifications9.1")}</p>
                  <p className="agreement-para">{t("(a)lineBonusCommissionQualifications9.1")}</p>
                  <p className="agreement-para">{t("(b)lineBonusCommissionQualifications9.1")}</p>
                  <p className="agreement-para">{t("(c)lineBonusCommissionQualifications9.1")}</p>

                  <p className="agreement-para sub-heading">{t("computationOfCommissionsDiscrepancies9.2")}</p>
                  <p className="agreement-para">{t("(a)lineComputationOfCommissionsDiscrepancies9.2")}</p>
                  <p className="agreement-para">{t("(b)lineComputationOfCommissionsDiscrepancies9.2")}</p>
                  <p className="agreement-para">{t("(c)lineComputationOfCommissionsDiscrepancies9.2")}</p>

                  <p className="agreement-para sub-heading">{t("adjustmentsBonusesCommissionsReturnedServices9.3")}</p>
                  <p className="agreement-para">{t("(a)lineAdjustmentsBonusesCommissionsReturnedServices9.3")}</p>
                  <p className="agreement-para">{t("(b)lineAdjustmentsBonusesCommissionsReturnedServices9.3")}</p>
                  <p className="agreement-para">{t("(c)lineAdjustmentsBonusesCommissionsReturnedServices9.3")}</p>

                  <h3 className="text-center links-heading item-heading-font"
                      style={{ fontSize: "20px", color: "#ee7c2c" }}>
                   10.0 <u>{t("orderingServices10.0")}</u>
                  </h3>
                  
                  <p className="agreement-para sub-heading">{t("generalServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para">(a) <span className="orange-noa"><u>{t("(a)bonusBuying")}</u></span>{t("(a)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(a)(i)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(a)(ii)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(a)(iii)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(a)(iv)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(a)(v)lineGeneralServiceOrderingPolicies10.1")}</p>

                  <p className="agreement-para">{t("(b)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para">{t("(c)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para">{t("(d)lineGeneralServiceOrderingPolicies10.1")}</p>
                  <p className="agreement-para">{t("(e)lineGeneralServiceOrderingPolicies10.1")}</p>

                  <p className="agreement-para sub-heading">{t("salesToCustomers10.2")}</p>
                  <p className="agreement-para">{t("(a)lineSalesToCustomers10.2")}</p>
                  <p className="agreement-para">{t("(b)lineSalesToCustomers10.2")}</p>

                  <p className="agreement-para sub-heading">{t("insufficientFunds10.3")}</p>
                  <p className="agreement-para">{t("(a)lineInsufficientFunds10.3")}</p>
                  <p className="agreement-para">{t("(b)lineInsufficientFunds10.3")}</p>
                  <p className="agreement-para">{t("(c)lineInsufficientFunds10.3")}</p>
                  <p className="agreement-para">{t("(d)lineInsufficientFunds10.3")}</p>
                  
                  <p className="agreement-para sub-heading">{t("creditCardPurchases10.4")}</p>
                  <p className="agreement-para">{t("(a)lineCreditCardPurchases10.4")}</p>
                  <p className="agreement-para">{t("(b)lineCreditCardPurchases10.4first")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa">{t("support@joinnoa.io")}</a>
                   {t("(b)lineCreditCardPurchases10.4second")}
                  </p>
                  
                  <p className="agreement-para sub-heading">{t("salesTaxObligation10.5")}</p>
                  <p className="agreement-para">{t("(a)lineSalesTaxObligation10.5")}</p>
                  <p className="agreement-para">{t("(b)lineSalesTaxObligation10.5")}</p>
                  <p className="agreement-para">{t("(c)lineSalesTaxObligation10.5")}</p>

                  <p className="agreement-para sub-heading">{t("refundPolicy10.6")}</p>
                  <p className="agreement-para mb-0-5" >{t("NOA Customers:")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)lineRefundPolicy10.6first")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa">{t("support@joinnoa.io")}</a>
                    {t("(i)lineRefundPolicy10.6second")}
                  </p>
                  <p className="agreement-para pd-l-3">{t("(ii)lineRefundPolicy10.6")}</p>


                  <h3 className="text-center links-heading item-heading-font"
                      style={{ fontSize: "20px", color: "#ee7c2c" }}>
                   11.0 <u>{t("noaOpportunity11.0")}</u>
                  </h3>


                  <p className="agreement-para sub-heading">{t("presentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para ">{t("linePresentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)linePresentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(ii)linePresentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(iii)linePresentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(iv)linePresentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(v)linePresentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(vi)linePresentationOfCompensationPlanIncomeClaims11.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(vii)linePresentationOfCompensationPlanIncomeClaims11.1")}</p>


                  <p className="agreement-para sub-heading">{t("events11.2")}</p>
                  <p className="agreement-para">{t("(a)lineEvents11.2")}</p>
                  <p className="agreement-para">{t("(b)lineEvents11.2")}</p>
                  
                  <p className="agreement-para sub-heading">{t("tradingPolicies11.3")}</p>
                  <p className="agreement-para">{t("(a)lineTradingPolicies11.3")}</p>
                  <p className="agreement-para">{t("(b)lineTradingPolicies11.3")}</p>
                  
                  <p className="agreement-para sub-heading">{t("salesRequirementsCompensationPlan11.4")}</p>
                  <p className="agreement-para">{t("1lineSalesRequirementsCompensationPlan11.4")}</p>


                  <h3 className="text-center links-heading item-heading-font"
                      style={{ fontSize: "20px", color: "#ee7c2c" }}>
                    12.0 <u>{t("proprietaryInformationTradeSecrets12.0")}</u>
                  </h3>

                  <p className="agreement-para sub-heading">{t("businessReportsListsProprietaryInformation12.1")}</p>
                   <p className="agreement-para">{t("1lineProprietaryInformationTradeSecrets12.1")}</p>


                  <p className="agreement-para sub-heading">{t("obligationOfConfidentiality12.2")}</p>
                   <p className="agreement-para">{t("1lineObligationOfConfidentiality12.2")}</p>
                   <p className="agreement-para pd-l-3">{t("2lineObligationOfConfidentiality12.2")}</p>
                   <p className="agreement-para pd-l-3">{t("3lineObligationOfConfidentiality12.2")}</p>


                  <p className="agreement-para sub-heading">{t("breachAndRemedies12.3")}</p>
                   <p className="agreement-para">{t("1lineBreachAndRemedies12.3")}</p>
                   

                  <p className="agreement-para sub-heading">{t("returnOfMaterials12.4")}</p>
                   <p className="agreement-para">{t("1lineReturnOfMaterials12.4")}</p>


                  <h3 className="text-center links-heading item-heading-font"
                      style={{ fontSize: "20px", color: "#ee7c2c" }}>
                    13.0 <u>{t("privacyPolicy13.0")}</u>
                  </h3>
                   <p className="agreement-para sub-heading">{t("introduction13.1")}</p>
                   <p className="agreement-para">{t("1lineIntroduction13.1")} {t("2lineIntroduction13.1")}</p>
                   
                   <p className="agreement-para sub-heading">{t("expectationOfPrivacy13.2")}</p>
                   <p className="agreement-para">{t("(a)lineExpectationOfPrivacy13.2")}</p>
                   <p className="agreement-para">{t("(b)lineExpectationOfPrivacy13.2")}</p>
                   
                   <p className="agreement-para sub-heading">{t("restrictionsOnDisclosureOfAccountInformation13.3")}</p>
                   <p className="agreement-para">{t("1lineRestrictionsOnDisclosureOfAccountInformation13.3")}</p>

                    
                    <h3 className="text-center links-heading item-heading-font"
                      style={{ fontSize: "20px", color: "#ee7c2c" }}>
                    14.0 <u>{t("advertisingPromotionalMaterialUseOfCompanyNamesAndTrademarks14.0")}</u>
                  </h3>
                   
                  <p className="agreement-para sub-heading">{t("displayingServices14.1")}</p>
                  <p className="agreement-para">{t("(a)lineDisplayingServices14.1")}</p>
                  <p className="agreement-para">{t("(b)lineDisplayingServices14.1")}</p>
                  <p className="agreement-para">{t("(c)lineDisplayingServices14.1")}</p>
                  
                  <p className="agreement-para pd-l-3">{t("(i)line(c)DisplayingServices14.1")}</p>
                  <p className="agreement-para pd-l-3">{t("(ii)line(c)DisplayingServices14.1")}</p>

                  <p className="agreement-para sub-heading">{t("useOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(a)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(b)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(c)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(d)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)line(d)UseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para pd-l-3">{t("(ii)line(d)UseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(e)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)line(e)UseOfCompanyNamesAndProtectedMaterials14.2")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa">{t("support@joinnoa.io")}</a>
                  </p>
                  <p className="agreement-para pd-l-3">{t("(ii)line(e)UseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para pd-l-3">{t("(iii)line(e)UseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(f)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(g)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(h)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(i)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>
                  <p className="agreement-para">{t("(j)lineUseOfCompanyNamesAndProtectedMaterials14.2")}</p>


                  <p className="agreement-para sub-heading">{t("faxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para">{t("(a)lineFaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)line(a)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(ii)line(a)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para">{t("(b)lineFaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para">{t("(c)lineFaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(ii)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(iii)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(iv)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(v)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(vi)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(vii)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(viii)line(c)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para">{t("(d)lineFaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)line(d)FaxesAndEmailLimitations14.3")}</p>
                  <p className="agreement-para pd-l-3">{t("(ii)line(d)FaxesAndEmailLimitations14.3")}</p>


                  <p className="agreement-para sub-heading">{t("internetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(a)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(b)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(c)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(d)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(e)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(f)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(g)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(h)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(i)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(j)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(k)lineInternetAndThirdPartyWebsiteRestrictions14.4first")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa">{t("support@joinnoa.io")}</a>
                    {t("(k)lineInternetAndThirdPartyWebsiteRestrictions14.4second")}
                  </p>
                  <p className="agreement-para">{t("(l)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(m)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>
                  <p className="agreement-para">{t("(n)lineInternetAndThirdPartyWebsiteRestrictions14.4")}</p>

                  <p className="agreement-para sub-heading">{t("advertisingAndPromotionalMaterials14.5")}</p>
                  <p className="agreement-para">{t("(a)lineAdvertisingAndPromotionalMaterials14.5")}</p>

                  <p className="agreement-para sub-heading">{t("testimonialPermission14.6")}</p>
                  <p className="agreement-para">{t("lineTestimonialPermission14.6")}</p>

                  <p className="agreement-para sub-heading">{t("telemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(a)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(b)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(c)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(d)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(e)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(f)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(g)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(h)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para">{t("(i)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)(i)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)(ii)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)(iii)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)(iv)lineTelemarketingLimitations14.7")}</p>
                  <p className="agreement-para pd-l-3">{t("(i)(v)lineTelemarketingLimitations14.7")}</p>


                  <h3 className="text-center links-heading item-heading-font"
                      style={{ fontSize: "20px", color: "#ee7c2c" }}>
                    15.0 <u>{t("internationalMarketing15.0")}</u>
                  </h3>
                  <p className="agreement-para">{t("lineInternationalMarketing15.0")}</p>


                  <h3 className="text-center links-heading item-heading-font"
                      style={{ fontSize: "20px", color: "#ee7c2c" }}>
                    16.0 <u>{t("glossary16.0")}</u>
                  </h3>
                  <p className="agreement-para"><span className="orange-noa"><u>{t("titleActiveAffiliate")}</u></span> {t("activeAffiliate")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleCompensationPlan")}</u></span> {t("compensationPlan")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleComplianceTeam")}</u></span> {t("complianceTeam")}
                  <a href="mailto:compliance@joinnoa.io"  className="orange-noa">{t("compliance@joinnoa.io")}</a>
                  </p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleCustomer")}</u></span> {t("customer")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleCustomerServiceTeam")}</u></span> {t("customerServiceTeam")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa"><u>{t("support@joinnoa.io")}</u></a>
                  </p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleDownline")}</u></span> {t("downline")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleSponsorOrSponsoringAffiliate")}</u></span> {t("sponsorOrSponsoringAffiliate")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleAffiliate")}</u></span> {t("affiliate")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleLineOfSponsorship")}</u></span> {t("lineOfSponsorship")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleOrganizationOrMarketingNetworkOrGenealogy")}</u></span> {t("organizationOrMarketingNetworkOrGenealogy")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleNoaMaterial")}</u></span> {t("noaMaterial")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titlePlacement")}</u></span> {t("placement")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleRecruitOrRecruiting")}</u></span> {t("recruitOrRecruiting")}</p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleSupportTeam")}</u></span> {t("supportTeam")}
                  <a href="mailto:support@joinnoa.io"  className="orange-noa">{t("support@joinnoa.io")}</a>
                  </p>
                  <p className="agreement-para"> <span className="orange-noa"><u>{t("titleUpline")}</u></span> {t("upline")}</p>


                  <div className="agreement-footer">
                    <p className="agreement-para"style={{marginBottom:"0.5rem"}}>NOA LABS LLC. 
                          <br />
                          IFZA Business Park, DDP,
                          <br />
                          Dubai Silicon Oasis,
                          <br />
                          Dubai, UAE</p>
                    <p className="agreement-para"style={{marginBottom:"0.5rem"}}>
                      <a href="https://joinnoa.io/" target="_blank"  className="orange-noa">{t("www.joinnoa.io")}</a>
                    </p>
                    <p className="agreement-para"style={{marginBottom:"0.5rem", marginTop:"0.5rem"}}>(213) 427 3457 4562</p>
                    <p className="agreement-para"style={{marginBottom:"0.5rem", marginTop:"0.5rem"}}>
                          <a href="mailto:support@joinnoa.io"
                            className="orange-noa"
                          >
                            support@joinnoa.io
                          </a>
                      </p>
                    <p className="agreement-para" style={{marginTop:"0.5rem"}}>© 2025 NOA LABS LLC. All rights reserved</p>
                  </div>

              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PoliciesProcedures;
